import styles from "./ProductStatusBox.module.scss";
import { ProductType } from "../../types/types";
import { GalleryButton } from "./components/GalleryButton";
import { ProductStatus } from "./components/ProductStatus";
import { Buttons } from "./components/Buttons";

type ProductStatusBoxUIProps = {
  handleImageClick: () => void;
  handleDescriptionCTA: () => void;
  handleCheckInStoreStockClick: () => void;
  image: string;
  title: string;
  price: string;
  productType?: ProductType;
  showStoreStockButton: boolean;
  statusMessage: string;
  showHowToGetIt: boolean;
  hideViewDescriptionLink: boolean;
  hideTitle?: boolean;
};

export const ProductStatusBoxUI = ({
  image,
  title,
  price,
  handleImageClick,
  handleDescriptionCTA,
  handleCheckInStoreStockClick,
  productType,
  showStoreStockButton,
  statusMessage,
  showHowToGetIt,
  hideViewDescriptionLink,
  hideTitle = false,
}: ProductStatusBoxUIProps) => {
  return (
    <div className={styles.container} data-component="ProductStatusBox">
      <GalleryButton
        handleImageClick={handleImageClick}
        image={image}
        title={title}
        useSmallImage={hideTitle}
      />
      <div className={styles.content}>
        <ProductStatus
          showHowToGetIt={showHowToGetIt}
          handleDescriptionCTA={handleDescriptionCTA}
          price={price}
          productType={productType}
          statusMessage={statusMessage}
          title={title}
          hideViewDescriptionLink={hideViewDescriptionLink}
          hideTitle={hideTitle}
        />
        {!hideTitle && (
          <Buttons
            handleCheckInStoreStockClick={handleCheckInStoreStockClick}
            productType={productType}
            showStoreStockButton={showStoreStockButton}
          />
        )}
      </div>
    </div>
  );
};
